<div class="form-group">

    <div class="password-input-btn">

        <label [for]="id" >{{title}} {{control | controlRequiredText}}</label>

        <input [type]="showPassword ? 'text' : 'password'"
        class="form-control" 
        [ngClass]="{'is-invalid':control.touched && control.invalid}" 
        [id]="id"
        [name]="id"
        [title]="title" 
        [maxlength]="maxlength"
        [placeholder]="placeholder" 
        [formControl]="control"
        style="background-image: none;"
         />

        <button type="button" class="btn btn-show-psw" (click)="showPassword = !showPassword"
            title="Mostrar o esconder contraseña"><i
                class="pj-ico pj-ico-ojo-pass pj-ico-140"></i>
        </button>
    </div>

    <div-validation-message 
    [control]="control" 
    [messageRequired]="messageRequired" 
    [messagePattern]="messagePattern"
    [messageSameValue]="'Las contraseñas ingresadas no coinciden.'"
    ></div-validation-message>

    <small *ngIf="showMessageHelp" class="form-text text-muted">(Mínimo 6 caracteres, incluya una letra mayúscula y un dígito)</small>

</div>